import { RootState } from 'common/redux/core/root.reducer';

export const syncLogDataSelector = (state: RootState) =>
    state.syncHistory.syncHistoryList.data?.data || [];
export const syncLogDataStatusSelector = (state: RootState) =>
    state.syncHistory.syncHistoryList.status;
export const syncLogDataPaginationSelector = (state: RootState) =>
    state.syncHistory.syncHistoryList.data?.pagination;
